// extracted by mini-css-extract-plugin
export default {"page_wrapper":"styles_page_wrapper__VWdI1","app_name":"styles_app_name__LBYbj"};